import { del } from '../index';

export const deleteTag = (familyId, id) => {
  return del(`family/${familyId}/tag/${id}`);
};